<template>
	<div class="enterprisewebsite" v-title :data-title="msg" data="informationdetail">  
		<leftnav class="fl"></leftnav>
		<div :class="userdata.userType ==1?'index_left':''" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader v-if="userdata.userType==1"></govheader>
	 <div class=""  :class="userdata.userType ==1?'index_left_centerpage flexcss':'oh centerpage flexcss newsdetail'" >
			<div class="leftconbox whitebox" v-if="pagetypes == 1">
				<div class="newstitle"> 
					<h3 class="title">{{title}}</h3> 
					<p class="tac por">
						<span style="margin-right:50px">发布时间：{{pagedata.publishTime}}</span> <span style="margin-right:50px" v-show="pagedata.notion !=''">所属领域： {{pagedata.notion}}</span> 
						<!-- <span v-show="pagedata.good>0 && pagedata.star>0" :class="pagedata.good==1?'stargrade1 redstargrade oh':'stargrade1 greenstargrade oh'" style="line-height: 18px;" >影响程度：<i style="position: relative;top: 2px;" v-for="stard in pagedata.star"></i></span> -->
						<!-- <span v-show="pagedata.good==0 && pagedata.star>0" class="stargrade1 stargrade" style="line-height: 18px;"  >影响程度：<i class="starfull" style="position: relative;top: 2px;" v-for="stard in pagedata.star"></i></span> -->
						<!-- <span :class="pagedata.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{pagedata.collectId == 0?'+添加收藏':'取消收藏'}}</span> -->
				</p> 
				</div>
				<div class="newscontent" v-html="pagedata.content"></div> 
				<dl class="newsDe_key" v-show="pagedata.keylist.length>0">
					<dt class="fl">关键词：</dt><dd class="fl"><span v-for="(item,i) in pagedata.keylist" :key="'key'+i" @click="tagrouter('/timeinforKey',7,'news',item.id,item.name)">{{item.name}}</span></dd>
				</dl>
				<div class="newcon-recom"  v-if="pageextend.policyDecode.length>0 || pageextend.policySource.length>0 ">
					<h3 class="title" >{{pageextend.policyDecode.length>0?'政策解读':"相关政策"}}</h3>
					<ul>
						<li v-for="(item,i) in pageextend.policyDecode" :key="item.title+i">
							<span class="onlyline fl">{{item.title}}</span> 
						</li>
						<li v-for="(item,i) in pageextend.policySource" :key="'source'+i" >
							<span class="onlyline fl">{{item.title}}</span> 
						</li>
					</ul>  
				</div>
			</div>
			<div class="leftconbox whitebox"  v-if="pagetypes == 2">
				<div class="newstitle"> 
					<h3 class="title">{{title}}</h3> 
					<p class="tac por">
						<span style="margin-right:50px" @click="routerlinkid('/enterprises',pagedata.stockCode)">相关公司： <em class="curp">{{pagedata.enterpriseName}}</em></span> 
						<span style="margin-right:50px">信息来源：<a :href="pagedata.sourceUrl" target="_blank">{{pagedata.source}}</a></span> 
						<span style="margin-right:50px">发布时间：{{pagedata.publishTime}}</span>
					</p> 
				</div>
				<div class="newscontent" v-html="pagedata.content"></div> 
			<!-- 	<dl class="newsDe_key" v-show="pagedata.keylist.length>0">
					<dt class="fl">关键词：</dt><dd class="fl"><span v-for="item in pagedata.keylist" @click="tagrouter('/timeinforKey',7,'news',item.id,item.name)">{{item.name}}</span></dd>
				</dl> 
				<div class="newcon-recom"  v-if="pageextend.policyDecode.length>0 || pageextend.policySource.length>0 ">
					<h3 class="title" >{{pageextend.policyDecode.length>0?'政策解读':"相关政策"}}</h3>
					<ul>
						<li v-for="item in pageextend.policyDecode" >
							<span class="onlyline fl">{{item.title}}</span> 
						</li>
						<li v-for="item in pageextend.policySource" >
							<span class="onlyline fl">{{item.title}}</span> 
						</li>
					</ul>  
				</div>-->
			</div>
			<div class="rightrecommend"  >
				<div class="whitebox hotinchain" v-if="userdata.userType>1 && pagetypes == 1" v-show="hotlist.length>0">
					<h4 class="title">热门产业事件链</h4>
					<ul>
						<li v-for="(item,i) in hotlist" :key="item.name+i">
							<span class="onlyline db" @click="routerlinkid('/eventChain',item.code,1)">{{item.name}}</span>
							<!-- <p class="stargrade fr"><i class="starfull" v-for="star in item.grade"></i><i class="stargray" v-for="star in (5-item.grade)"></i></p> -->
							</li>
					</ul> 
				</div> 
				<div class="whitebox hotinchain" v-if="userdata.userType==1 && pagetypes == 1" v-show="hotpolicy.length>0">
					<h4 class="title">热门产业政策</h4>
					<ul>
						<li v-for="(item,i) in hotpolicy" :key="'hotpolicy'+i" v-show="i<4">
							<span class="onlyline db" @click="routerlinkid('/news',item.id,1)">{{item.title}}</span>
							<!-- <p class="stargrade fr"><i class="starfull" v-for="star in item.grade"></i><i class="stargray" v-for="star in (5-item.grade)"></i></p> -->
							</li>
					</ul> 
				</div>
				<div class="whitebox hotinchain" v-if="pagetypes == 2" v-show="relatednews.length>0">
					<h4 class="title">相关资讯动态</h4>
					<ul>
						<li v-for="(item,i) in relatednews" :key="'relatednews'+i" v-show="i<4">
							<span class="onlyline db" @click="routerlinkid('/news',item.id,2)">{{item.title}}</span>
							<!-- <p class="stargrade fr"><i class="starfull" v-for="star in item.grade"></i><i class="stargray" v-for="star in (5-item.grade)"></i></p> -->
							</li>
					</ul> 
				</div>
			</div> 
		</div>
			
		</div>
		
		<footerbar v-if="userdata.userType>1"></footerbar>
	</div>
</template>

<script> 
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'newsdetail',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				msg:"",
				pagetypes:1,
				curindex:7,
				newsid:1,
				hotlist:[], 
				hotpolicy:[],
				pageextend:{policyDecode:[],policySource:[]},
				pagedata:{star:0,content:"",notion:'',publishTime:"",keylist:[]},
				title:"", relatednews:[],
				userdata:{},
			}},  
		created() { 
			this.$nextTick(() => {
			        // 禁用右键
			        document.oncontextmenu = new Function("event.returnValue=false");
			        // 禁用选择
			        document.onselectstart = new Function("event.returnValue=false");
			      }); 
			this.userdata = this.getuseriformation();
			this.newsid=this.$route.query.id*1;
			this.pagetypes = this.$route.query.type ? this.$route.query.type : 1; 
				// this.gethottopic()
			},
			mounted() { 
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			if(this.pagetypes == 1){
				this.getpagelist();
				if(this.userdata.userType==1){
					this.getpolicylist();
				} 
			}else{
				 this.getnewsdetail();
				// this.getrelatednews();
					this.curindex=50;
			}
			
			},
			methods:{
				//添加删除收藏
				collectFun(){
					// console.log(this.companyinfor.collectId,this.companyinfor);
					this.listToggleCollect(this.pagedata,'acoc'); 
				},  
				getrelatednews(enterpriseid){
						var ajaxurl=this.$api.cyl.enterprisenews.list()+'?date=month&stockCode='+enterpriseid+'&page=1';
						var _this=this;
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						console.log(ajaxurl)
						console.log('获取相关企业资讯列表',res.data)
						if (res.data.success) {
							_this.relatednews=res.data.list.filter(list=>{
								return list.id!=_this.newsid;
							});
							 _this.bus.$emit('loading', false);
							//  _this.totalPage = res.data.totalPage;
							//  _this.pageSize = res.data.pageSize;
							//  _this.total = res.data.totalRecord; 
							// _this.bus.$emit('loading', false); 
						} else {
							
						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
					
					
				},
				getnewsdetail(){
					var _this=this;
					console.log(this.$api.cyl.enterprisenews.detail()+'?id='+this.newsid)
					this.$axios.get(this.$api.cyl.enterprisenews.detail()+'?id='+this.newsid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// 11-9 资讯详情页数据
						// console.log(res.data );
						_this.pagedata=res.data.data;   
						console.log(res.data.data) ;
						document.title=res.data.data.title;
						_this.title=res.data.data.title;
						_this.getrelatednews(res.data.data.stockCode);
						// _this.bus.$emit('loading',false);
					// _this.chainnodelist=; 
					})
				},
				getpagelist(){
					var _this=this;
					this.$axios.get(this.$api.cyl.OCNNews.detail()+'?id='+this.newsid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// 11-9 稍微有点数据
						console.log(res.data );
						_this.pagedata=res.data.data;  
						// _this.pageextend=res.data.extend;
						if(res.data.extend != null){
							 _this.pageextend.policyDecode=res.data.extend.policyDecode == undefined?[]:res.data.extend.policyDecode;
							 _this.pageextend.policySource=res.data.extend.policySource == undefined?[]:res.data.extend.policySource;
								// console.log(_this.pageextend.policySource,_this.pageextend.policyDecode);
								// console.log(res.data.extend.policySource,res.data.extend.policyDecode);
						}; 
						_this.pagedata.content=_this.pagedata.content.replace(new RegExp('<p><br/></p>','g'),'');
						_this.pagedata.keylist=_this.taglistfun(_this.pagedata.keywordsText,_this.pagedata.keywords);
						// console.log();
						_this.hotlist=res.data.list; 
						document.title=res.data.data.title;
						_this.title=res.data.data.title;
						_this.bus.$emit('loading',false);
					// _this.chainnodelist=; 
					}) 
				},  
				getpolicylist(){
					var _this= this;
					var ajaxurl = this.$api.cyl.news.list()+"?type=2&bigClass=30008";
					this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// console.log("政策链",res);
						if(res.data.code<1){
							_this.hotpolicy= res.data.list;
						}
						else{ 
								
						} 
					}).catch(function (error) {
						// 请求失败处理 console.log(error);
					});  
				}
		} 
	}
	
	
	
</script>

<style scoped="scoped">  
.leftconbox{
	min-height: 840px;
}
</style>   
